import ApiBase from './base/ApiBase'
import { ProficiencyGroupType } from '../Enums';

class ProficiencyGroupClient extends ApiBase {
    private controllerName: string = 'ProficiencyGroup';

    async Create(name: string, weight: number, type: ProficiencyGroupType, signal?: AbortSignal): Promise<string> {
        let dto = { Name: name, Type: type, Weight: weight };
        return this.PostAsync(`${this.controllerName}`, dto, signal);
    }

    async Delete(id: string, signal?: AbortSignal): Promise<void> {
        return this.DeleteAsync(`${this.controllerName}/${id}`, signal);
    }

    async GetAll(signal?: AbortSignal): Promise<ProficiencyGroup[]> {
        return this.GetAsync(`${this.controllerName}`, signal);
    }

    async Update(id: string, name: string, weight: number, type: ProficiencyGroupType, signal?: AbortSignal): Promise<void> {
        let dto = new ProficiencyGroup();
        dto.Id = id;
        dto.Type = type;
        dto.Name = name;
        dto.Weight = weight;

        return this.PutAsync(`${this.controllerName}/${id}`, dto, signal);
    }

}

export class ProficiencyGroup {
    Id: string;
    Type: ProficiencyGroupType;
    Name: string;
    Weight: number;
    IsDeleted: boolean;
    LastUpdateDate: string;
}

export enum ProficiencyGroupErrors {
    Create = 'Error creating ProficiencyGroup',
    Delete = 'Error deleting ProficiencyGroup',
    Get = 'Error loading ProficiencyGroups',
    Update = 'Error saving ProficiencyGroup',

}

export default ProficiencyGroupClient;